import { Helmet } from 'react-helmet';

import SessaoInformativa from '../global/SessaoInformativa';
import InformacoesProdutos from '../global/ModuleInformacoesProdutos';
import FormOdontoBanner from './FormOdontoBanner';
// import ConteudoSessaoInfo from '../global/ConteudoSessaoInfo';
// import sessaoInfoLp from '../global/SessaoInfoLp';
import FaqOdonto from './Faq';
import PacotesPME from './PacotesPME';
import VantagensPME from './VantagensPME';
import RedeCredenciada from './RedeCredenciada';

export default function IndexOdonto() {
  return (
    <div>
      <Helmet>
        <title>Plano Odontológico Empresarial | SulAmérica PME</title>
        <meta
          name="description"
          content="Plano odontológico empresarial SulAmérica para PME. Sem carência, cobertura nacional e condições especiais para sua empresa. Cuide da saúde bucal da sua equipe."
        />
        <meta
          name="keywords"
          content="Prime Secure, Seguros, Insurance, Insurtech, Corretora de Seguros, MarketPlace de Seguros, Odonto Empresarial, Plano Odonto PME, Plano Odontológico para Empresas, SulAmérica Empresarial, Odonto Corporativo"
        />
        <meta
          property="og:title"
          content="Plano Odontológico Empresarial SulAmérica"
        />
        <meta
          property="og:description"
          content="Planos odontológicos empresariais com cobertura completa e sem carência. Cuide da saúde bucal dos seus colaboradores."
        />
        <meta
          property="og:image"
          content="https://banco-de-imagens-webapp-primesecure.s3.sa-east-1.amazonaws.com/social-odonto-by-primesecure.png"
        />
        <meta
          property="og:url"
          content="https://www.odontosulamerica.com.br/"
        />
        <link rel="canonical" href="https://www.odontosulamerica.com.br/" />
      </Helmet>
      <FormOdontoBanner />
      <SessaoInformativa
        InformacoesProdutos={InformacoesProdutos}
        productId="5"
      />
      {/*<SimpleFormSection />*/}
      <PacotesPME />
      <VantagensPME />
      <RedeCredenciada />
      {/* <ConteudoSessaoInfo sessaoInfoLp={sessaoInfoLp} sessaoInfoId="5" /> */}
      <FaqOdonto />
    </div>
  );
}
